import React from 'react';
import { Container, Flex } from '../../../view/Containers';
import { HighlightedPLight, Paragraph } from '../../../view/Paragraph';
import { VerticalCard } from '../../../view/VerticalCard';
import ecology1 from './img/ecology_1.png';
import ecology2 from './img/ecology_2.png';
import ecology3 from './img/ecology_3.png';
import ecology4 from './img/ecology_4.png';
import ecology5 from './img/ecology_5.png';
import ecology6 from './img/ecology_6.png';


export const EcologySectionBody = (): JSX.Element => (
  <>
    <Container padding inColor>
      <article>
        <HighlightedPLight as="h2">
          W małej wiosce na pograniczu Lubelszczyzny,
          Mazowsza i Podlasia prowadzimy nasze gospodarstwo owocowo – warzywne.
          Nasze plantacje prowadzone są w 100% ekologicznie i naturalnie
          bez chemicznych oprysków i nawozów
        </HighlightedPLight>
        <Paragraph>
          Dzięki temu masz pewność, że produkty z naszych warzyw i owoców są w pełni zdrowe,
          naturalne i bezpieczne dla zdrowia ponieważ nie zawierają
          szkodliwych pozostałości chemicznych po opryskach.
          Gospodarstwo usytuowane jest z dala od dróg (zarówno tranzytowych jak i tych mniejszych),
          co gwarantuje także brak zanieczyszczeń od transportowych.
        </Paragraph>
      </article>
    </Container>
    <Container padding inColor>
      <Flex responsive>
        <VerticalCard image={ecology1} imageNumber="1" header="Warzywa" upperSubHeader="certyfikaty">
          Abyście mieli pewność, że nasze warzywa i
          przetwory są w pełni zdrowe przystąpiliśmy do procesu certyfikacji
          poprzez organizację Bio-cert. Obecnie certyfikowane ekologiczne warzywa z naszej plantacji
          to między innymi: buraki, czosnek, kapusta, marchew, ogórek, por, pomidor, pietruszka,
          szczypior, seler, rzodkiewka, brokuł, cebula, kalarepa, bakłażan i inne.
        </VerticalCard>
        <VerticalCard image={ecology2} imageNumber="2" header="Owoce" upperSubHeader="certyfikaty">
          Proces certyfikacji polega na tym iż
          owoce uprawiane są zgodnie z zasadami ekologicznej produkcji,
          ale zanim otrzymają certyfikat muszą przejść okres przestawienia - inaczej konwersję.
          Obecnie nasze maliny, truskawki, są własnie w okresie konwersji,
          co oznacza że są stale badane i sprawdzane czy sa ekologiczne,
          a lada chwila otrzymają certyfikat. Natomiast porzeczki, agrest, aronia, jabłka,
          gruszki i śliwki są już certyfikowane jako ekologiczne.
        </VerticalCard>
      </Flex>
      <Flex responsive>
        <VerticalCard image={ecology3} imageNumber="3" header="Pszczoły" upperSubHeader="Ochrona ekosystemów">
          W naszym gospodarstwie dbamy o pszczoły. Między rzędami owoców rosną łąki kwietne.
          Dla pszczół murarek przygotwaliśmy kilka specjalnych domków,
          które rozmieszczone są po naszych polach. W pobliżu malin zlokalizowane sa także ule.
          Co jednak najważniejsze nie używamy środków ochrony roślin -
          dzięki czemu nie trujemy pszczół - mają one u nas idealne warunki!
        </VerticalCard>
        <VerticalCard image={ecology4} imageNumber="4" header="Naturalne nawozy" upperSubHeader="lepsze dla Ciebie i natury">
          Stosując nawozy sztuczne w rolnictwie przyspiesza się wzrost roślin,
          a z drugiej strony zaburza naturalne
          środowisko - w wielu przypadkach działają szkodliwie na glebę,
          na organizmy w niej żyjące i na rośliny,
          które nie wytwarzają witamin i minerałów zgodnie z naturą.
          Dlatego my stosujemy jedynie nawozy naturalne i organiczne.
          Jesienią obornik zwierzęcy, a wiosną i latem mieszanki gnojówek roślinnych np. z pokrzywy
        </VerticalCard>
      </Flex>
      <Flex responsive>
        <VerticalCard image={ecology5} imageNumber="5" header="Ginące gatunki" upperSubHeader="Zachowanie bioróżnorodności">
          Nasze uprawy to nie tylko popularne owoce jak malina czy borówka.
          Niedawno na polach rozpoczęliśmy uprawę mniej znanych, czasem już zapomnianych,
          a niezwykle zdrowych owoców jak aronia czy świdośliwa.
          Do upraw dodaliśmy też rokitnik, głóg i jarząb szwedzki.
        </VerticalCard>
        <VerticalCard image={ecology6} imageNumber="6" header="Pakowanie" upperSubHeader="Ochrona środowiska">
          Nasze przetwory pakujemy w szkło,
          które potem możecie wykorzystać w domu,
          a wysłane przez nas paczki wypełniamy tekturami,
          a nie folią.
          Często korzystamy też z kartonów z recyklingu.
        </VerticalCard>
      </Flex>
    </Container>
  </>
);
